import { useHistory, useLocation } from 'react-router-dom';
import { Container } from './styled';
import { OptionMenu } from './OptionMenu';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { AiOutlineAreaChart } from 'react-icons/ai';
import { FaUsers } from 'react-icons/fa';
import { IoVideocam } from "react-icons/io5";


export function Reports(props) {
    const { isVisibility } = props;

    const history = useHistory();
    const location = useLocation();

    const titleMenuUsers = () => {
        return (
            <span className='title--'>
                {`Usuários`}
                <FaUsers />
            </span>
        )
    };

    const titleMenuCustomerServices = () => {
        return (
            <span className='title--'>
                {`Atendimento`}
                <RiCustomerService2Fill />
            </span>
        )
    };

    const titleMenuCharts = () => {
        return (
            <span className='title--'>
                {`Gráficos`}
                <AiOutlineAreaChart />
            </span>
        )
    };

    const titleMenuTeleService = () => {
        return (
            <span className='title--'>
                {`Teleatendimento`}
                <IoVideocam />
            </span>
        )
    };

    const isSelected = (refPathname) => {
        const { pathname } = location;
        return (refPathname === pathname)
    }
    function handleClick(pathname) {
        history.push(pathname);
    };

    return (
        <Container visibility={isVisibility ? 1 : 0}>
            {/* <OptionMenu title={titleMenuUsers()}>
                <li
                    onClick={
                        () => { handleClick(`/reports/users/status`) }
                    }
                    className={`${(isSelected(`/reports/users/status`)) ? 'selected' : ''}`}
                >
                    {`Status`}
                </li>
            </OptionMenu> */}
            <OptionMenu title={titleMenuCharts()}>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/consumption`) }
                    }
                    className={`${(isSelected(`/reports/charts/consumption`)) ? 'selected' : ''}`}
                >
                    {`Consumo`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/performance`) }
                    }
                    className={`${(isSelected(`/reports/charts/performance`)) ? 'selected' : ''}`}
                >
                    {`Quantidade de atendimentos`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/performance-users`) }
                    }
                    className={`${(isSelected(`/reports/charts/performance-users`)) ? 'selected' : ''}`}
                >
                    {`Quantidade de atendimentos por Usuário`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/service-time`) }
                    }
                    className={`${(isSelected(`/reports/charts/service-time`)) ? 'selected' : ''}`}
                >
                    {`Tempo de atendimento`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/service-time-groups`) }
                    }
                    className={`${(isSelected(`/reports/charts/service-time-groups`)) ? 'selected' : ''}`}
                >
                    {`Tempo de espera - setores`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/charts/peakattendance`) }
                    }
                    className={`${(isSelected(`/reports/charts/peakattendance`)) ? 'selected' : ''}`}
                >
                    {`Pico de atendimentos`}
                </li>
            </OptionMenu>
            <OptionMenu title={titleMenuCustomerServices()}>
                <li
                    onClick={
                        () => { handleClick(`/reports/customer-service/total`) }
                    }
                    className={`${(isSelected(`/reports/customer-service/total`)) ? 'selected' : ''}`}
                >
                    {` Quantidade de atendimentos`}
                </li>
                <li
                    onClick={
                        () => { handleClick(`/reports/customer-service/time-wait-group`) }
                    }
                    className={`${(isSelected(`/reports/customer-service/time-wait-group`)) ? 'selected' : ''}`}
                >
                    {`Tempo de espera - Setores`}
                </li>
            </OptionMenu>
            <OptionMenu title={titleMenuTeleService()}>
                <li
                    onClick={
                        () => { handleClick(`/reports/TeleService/VideoCall`) }
                    }
                    className={`${(isSelected(`/reports/TeleService/VideoCall`)) ? 'selected' : ''}`}
                >
                    {` Videochamadas`}
                </li>
            </OptionMenu>
        </Container>
    );
}
